import React, { FC, ReactNode, memo, useEffect, useState } from 'react';

import { PopoverVirtualElement } from '@mui/material';

import CustomPopover from '../CustomPopover';
import HocWithProps from '../HocWithProps';

interface SubmenuRendererProps {
  submenu: FC<{ onClose: () => void }> | undefined;
  handleClose: () => void;
  anchorEl:
    | null
    | Element
    | (() => Element)
    | PopoverVirtualElement
    | (() => PopoverVirtualElement);
}

const SubmenuRenderer: FC<SubmenuRendererProps> = ({
  submenu,
  anchorEl,
  handleClose,
}) => {
  const [resolvedSubmenu, setResolvedSubmenu] = useState<ReactNode>(null);

  useEffect(() => {
    const fetchSubmenu = async () => {
      if (submenu) {
        const resolved = await HocWithProps(submenu)({ onClose: handleClose });
        setResolvedSubmenu(resolved);
      }
    };

    fetchSubmenu();
  }, [submenu, handleClose]);

  return resolvedSubmenu ? (
    <CustomPopover anchorEl={anchorEl} onClose={handleClose}>
      {resolvedSubmenu}
    </CustomPopover>
  ) : null;
};

export default memo(SubmenuRenderer);
